import { render, staticRenderFns } from "./SectionHeader.vue?vue&type=template&id=5331b8c5&scoped=true"
var script = {}
import style0 from "./SectionHeader.vue?vue&type=style&index=0&id=5331b8c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5331b8c5",
  null
  
)

export default component.exports